import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinner, NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { CustomerService } from '../../_services/customer.service';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from '../../_services/google-analytics.service';
import { MatDialogTitle, MatDialogClose } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    imports: [MatDialogTitle, MatIcon, MatDialogClose, FormsModule, ReactiveFormsModule, MatFormField, MatInput, NgxSpinnerComponent, MatError, AsyncPipe]
})
export class ForgotPasswordComponent implements OnInit {
  private readonly formBuilder = inject(UntypedFormBuilder);
  private readonly spinnerService = inject(NgxSpinnerService);
  private readonly customerService = inject(CustomerService);
  private readonly router = inject(Router);
  private readonly googleAnalyticsService = inject(GoogleAnalyticsService);

  public email = new UntypedFormControl('', [Validators.required, Validators.email]);
  public spinner$!: Observable<NgxSpinner>;
  public emailForm!: UntypedFormGroup;
  public errorMessage = '';
  public successMessage = '';

  constructor() {
    this.emailForm = this.formBuilder.group({
      email: this.email
    });
  }

  ngOnInit(): void {
    this.spinner$ = this.spinnerService.spinnerObservable;
  }

  public async recoverPassword(): Promise<void> {
    this.errorMessage = this.getErrorMessage();
    if (!this.errorMessage) {
      await this.spinnerService.show();
      const didSucceed = await this.customerService.sendPasswordRecoveryEmail(this.email.value);
      await this.spinnerService.hide();
      this.googleAnalyticsService.eventEmitter('forgot_password', 'Forgot Password', 'Forgot Password', 'Forgot Password', 1);

      if (!didSucceed) {
        this.errorMessage = 'Unable to recover password. Please try again later.';
      } else {
        this.successMessage = 'Password recovery email sent. Please check your email.';
      }
    }
  }

  private getErrorMessage(): string {
    if (this.email.hasError('required')) {
      return 'Please enter your email';
    }

    return this.email.hasError('email') ? 'Not a valid email' : '';
  }

}
